export default __webpack_public_path__ + "recenter-1200-b74d02b98f82451d99afac331b45547b.png";